import { getRaw, patch } from "./client";
import type { AccountPatch, RegisteredAccount } from "../types/account";

/**
 * The client's registered bank and card accounts.
 *
 * Served at `/accounts/registered`: the backend keeps `/accounts` for the
 * review screen's pick list (accounts/router.py REGISTERED_PATH).
 */
export async function listRegisteredAccounts(clientId: number): Promise<RegisteredAccount[]> {
  const body = await getRaw<{ data: RegisteredAccount[] }>(
    `/api/clients/${clientId}/accounts/registered`,
  );
  return body.data;
}

/**
 * Answer one account's question; resolves with the row as the server now has it.
 *
 * The body carries only the fields given (the schema refuses an explicit
 * null). A refusal rejects with an ApiClientError carrying the server's code
 * and sentence word for word (api/client.ts).
 */
export async function patchAccount(
  clientId: number,
  rowId: number,
  body: AccountPatch,
): Promise<RegisteredAccount> {
  return patch<RegisteredAccount>(`/api/clients/${clientId}/accounts/${rowId}`, body);
}
